"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterplanetaryTrade = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../../cards/render/CardRenderer");
var InterplanetaryTrade = (function (_super) {
    __extends(InterplanetaryTrade, _super);
    function InterplanetaryTrade() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.INTERPLANETARY_TRADE,
            tags: [Tags_1.Tags.SPACE],
            cost: 27,
            metadata: {
                cardNumber: 'X05',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(1); });
                    b.slash().diverseTag();
                }),
                description: 'Increase your M€ production 1 step per different tag you have in play, including this.',
                victoryPoints: 1,
            },
        }) || this;
    }
    InterplanetaryTrade.prototype.play = function (player) {
        var availableTags = player.getDistinctTagCount(true, Tags_1.Tags.SPACE);
        player.addProduction(Resources_1.Resources.MEGACREDITS, availableTags, { log: true });
        return undefined;
    };
    InterplanetaryTrade.prototype.getVictoryPoints = function () {
        return 1;
    };
    return InterplanetaryTrade;
}(Card_1.Card));
exports.InterplanetaryTrade = InterplanetaryTrade;
